import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import withChatUserGroup from 'modules/shell/hoc/withChatUserGroup';
import {
  DCL_MATCH_DATE,
  STANLEY_ELIGIBLE_CLIENT_GROUP,
  MY_CLIENTS_NMVIP_GROUP,
  MARKETING_PILLS_CC_AND_GLOBAL_SEARCH,
  MY_CHAT_CLIENTS_GROUP,
  MY_CLIENTS_TWO_TRIPS_GROUP,
  DIGITAL_CLIENT_LEAD,
  MY_CLIENTS_RELATIONSHIP_GROUP,
  MY_CLIENTS_FIRST_TRIP_GROUP,
  MY_CLIENTS_DCL_GROUP,
} from 'constants/featureToggleNames';
import ClientListItemGeneral from './ClientListItemGeneral';
import styles from './ClientListItemGeneral.styles';

const mapStateToProps = ({ user: { data } }) => ({
  userBrand: data.brand,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withStyles(styles),
  withChatUserGroup(),
  withFeatureToggles({
    isStanleyEligibleGroupEnabled: STANLEY_ELIGIBLE_CLIENT_GROUP,
    isDclDateMatchEnabled: DCL_MATCH_DATE,
    isDigitalClientLeadEnabled: DIGITAL_CLIENT_LEAD,
    isMatchedClientsGroup: MY_CLIENTS_DCL_GROUP,
    isNMVipGroupEnable: MY_CLIENTS_NMVIP_GROUP,
    isMyClientsFirstTripGroup: MY_CLIENTS_FIRST_TRIP_GROUP,
    isMyClientsTwoTripsGroup: MY_CLIENTS_TWO_TRIPS_GROUP,
    isMyClientsRelationshipGroup: MY_CLIENTS_RELATIONSHIP_GROUP,
    isMyChatClientsGroup: MY_CHAT_CLIENTS_GROUP,
    isMarketingPillsCcAndGlobalSearchEnabled: MARKETING_PILLS_CC_AND_GLOBAL_SEARCH,
  }),
)(ClientListItemGeneral);
